import { useEffect, useState } from "react";
import "./aboutUs.scss";
import axios from "axios";
import AboutUsTemplate from "componets/templates/aboutUsTemplate/aboutUsTemplate";
import { baseURL } from "utilities/variables";
const AboutUs = () => {
  const [sobreNosotros, setSobreNosotros] = useState(undefined);
  const [galeria, setGaleria] = useState(undefined);
  const [misionVision, setMisionVision] = useState(undefined);
  const [historia, setHistoria] = useState(undefined);
  const [directorio, setDirectorio] = useState(undefined);
  const [mapaSede, setMapaSede] = useState(undefined);
  const [direccionSede, setDireccionSede] = useState(undefined);
  const [docentes, setDocentes] = useState(undefined);
  const [planeacion, setPlaneacion] = useState(undefined);
  const [relacionesI, setRelacionesI] = useState(undefined);
  const [secretariaSede, setSecretariaSede] = useState(undefined);
  const menuOptions = {
    categories: [
      {
        categoryName: "Información General",
        options: [
          { name: "Sobre nosotros", value: "sobreNosotros" },
          { name: "Galería", value: "galeria" },
          { name: "Misión y visión", value: "misionVision" },
          { name: "Historia", value: "historia" },
          { name: "Directorio", value: "directorio" },
          { name: "Mapas de sede", value: "mapaSede" },
        ],
      },
      {
        categoryName: "Vicerrectoría de sede",
        options: [
          { name: "Dirección de la sede", value: "direccionSede" },
          { name: "Docentes", value: "docentes" },
          { name: "Pleaneación", value: "planeacion" },
          { name: "Relaciones interinstitucionales", value: "relacionesI" },
          { name: "Secretaría de la sede", value: "secretariaSede" },
        ],
      },
    ],
  };

  const [data, setData] = useState({
    sobreNosotros: sobreNosotros,
    galeria: galeria,
    misionVision: misionVision,
    historia: historia,
    directorio: directorio,
    mapaSede: mapaSede,
    direccionSede: direccionSede,
    docentes: docentes,
    planeacion: planeacion,
    relacionesI: relacionesI,
    secretariaSede: secretariaSede,
  });
  useEffect(() => {
    let auxData = {
      sobreNosotros: sobreNosotros,
      galeria: galeria,
      misionVision: misionVision,
      historia: historia,
      directorio: directorio,
      mapaSede: mapaSede,
      direccionSede: direccionSede,
      docentes: docentes,
      planeacion: planeacion,
      relacionesI: relacionesI,
      secretariaSede: secretariaSede,
    };
    setData(auxData);
  }, [
    sobreNosotros,
    galeria,
    misionVision,
    historia,
    directorio,
    mapaSede,
    direccionSede,
    docentes,
    planeacion,
    relacionesI,
    secretariaSede,
  ]);
  useEffect(() => {
    axios
      .get(
        baseURL +
          "/api/acerca-de?populate=docentes.docentes.fotografia%2C%20planeacion%2C%20misionVision%2C%20directorio%2C%20relacionesInterinstitucionales%2C%20secretariaSede.consejoSede%2CsecretariaSede.consejoEscuelas%2C%20secretariaSede.representaciones%2C%20galeria%2C%20sobreNosotros%2C%20historia%2C%20mapaSede%2C%20direccionSede%2C%20galeria.imagenes%2C%20direccionSede.imagen"
      )
      .then((response) => {
        let auxData = response.data.data;
        //Darle un formato más sencillo a los datos:

        //Datos Sobre Nosotros
        let facilSobreNosotros = { descriptionMD: "" };
        facilSobreNosotros.descriptionMD =
          auxData.attributes.sobreNosotros.descripcion;
        setSobreNosotros(facilSobreNosotros);

        //Datos Historia
        let facilHistoria = { descriptionMD: "" };
        facilHistoria.descriptionMD = auxData.attributes.historia.descripcion;
        setHistoria(facilHistoria);

        //Datos de Mapa
        let facilMapa = { descriptionMD: "" };
        facilMapa.descriptionMD = auxData.attributes.mapaSede.descripcion;
        setMapaSede(facilMapa);

        //Datos de Galeria
        let facilGaleria = { descriptionMD: "", images: [] };
        let auxImages = auxData.attributes.galeria.imagenes.data;
        auxImages.map((img) =>
          facilGaleria.images.push({
            src: baseURL + img.attributes.url,
            alt: "Imagen de galería",
          })
        );
        facilGaleria.descriptionMD = auxData.attributes.galeria.descripcion;
        setGaleria(facilGaleria);

        //Datos de Dirección
        let facilDireccion = { descriptionMD: "", imgSrc: "", imgAlt: "" };
        let auxImagen = auxData.attributes.direccionSede.imagen.data;
        facilDireccion.imgSrc = baseURL + auxImagen.attributes.url;
        facilDireccion.imgAlt = "Imagen de dirección de sede";
        facilDireccion.descriptionMD =
          auxData.attributes.direccionSede.descripcion;
        setDireccionSede(facilDireccion);

        //Datos de misión y visión

        let facilMisionVision = { descriptionMD: "" };
        facilMisionVision.descriptionMD =
          auxData.attributes.misionVision.descripcion;
        setMisionVision(facilMisionVision);

        //Datos de planeación
        let facilPlaneacion = { descriptionMD: "" };
        facilPlaneacion.descriptionMD =
          auxData.attributes.planeacion.descripcion;
        setPlaneacion(facilPlaneacion);

        //Datos de directorio
        let facilDirectorio = {
          descriptionMD: "",
          socialMedia: {
            facebook: "",
            instagram: "",
            twitter: "",
            youtube: "",
          },
        };
        facilDirectorio.descriptionMD =
          auxData.attributes.directorio.descripcion;
        facilDirectorio.socialMedia.facebook =
          auxData.attributes.directorio.facebook;
        facilDirectorio.socialMedia.twitter =
          auxData.attributes.directorio.twitter;
        facilDirectorio.socialMedia.youtube =
          auxData.attributes.directorio.youtube;
        facilDirectorio.socialMedia.instagram =
          auxData.attributes.directorio.instagram;
        setDirectorio(facilDirectorio);

        //Datos de docentes
        let facilDocentes = { descriptionMD: "", professors: [] };

        //{img: profesorImg, tag: "Profesor asociado", name: "Guillermo Toro", email: "GuiToro@unal.edu.co", area: "Geología", phoneNumber: "3165000 EXT. 435", cvLacLink: "HTTP://Google.com", investigationLink: "HTTP://Google.com"}
        facilDocentes.descriptionMD = auxData.attributes.docentes.descripcion;
        let docentesAux = auxData.attributes.docentes.docentes;
        let docentes = [];
        let docenteAux = {
          img: "",
          tag: "",
          name: "",
          email: "",
          area: "",
          phoneNumber: "",
          cvLacLink: "",
          investigationLink: "",
        };
        docentesAux.forEach((docente) => {
          docenteAux.img = baseURL + docente.fotografia.data.attributes.url;
          docenteAux.tag = docente.etiqueta;
          docenteAux.email = docente.correo;
          docenteAux.area = docente.area;
          docenteAux.name = docente.nombre;
          docenteAux.phoneNumber = docente.telefono;
          docenteAux.cvLacLink = docente.cvLac;
          docenteAux.investigationLink = docente.grupoInvestigacion;
          docentes.push(docenteAux);
          docenteAux = {};
        });
        facilDocentes.professors = docentes;
        setDocentes(facilDocentes);

        //Datos de relaciones interinstitucionales
        let facilRelacionesI = { descriptionMD: "", DRELink: "" };
        facilRelacionesI.descriptionMD =
          auxData.attributes.relacionesInterinstitucionales.descripcion;
        facilRelacionesI.DRELink =
          auxData.attributes.relacionesInterinstitucionales.DREVinculo;
        setRelacionesI(facilRelacionesI);

        //Datos de secretaría de sede

        let facilSecretariaSede = auxData.attributes.secretariaSede;
        setSecretariaSede(facilSecretariaSede);
      });
  }, []);
  return (
    <div className="about-us__main-container">
      {data.misionVision !== undefined &&
      data.sobreNosotros !== undefined &&
      data.galeria !== undefined &&
      data.historia !== undefined &&
      data.mapaSede !== undefined &&
      data.direccionSede !== undefined &&
      data.planeacion !== undefined &&
      data.directorio !== undefined &&
      data.docentes !== undefined &&
      data.relacionesI !== undefined &&
      data.secretariaSede !== undefined ? (
        <AboutUsTemplate menuOptions={menuOptions} data={data} />
      ) : (
        "No se han podido cargar los datos correctamente"
      )}
    </div>
  );
};

export default AboutUs;
